<template>
    <ValidationObserver ref="form">
        <h2 class="profile__title">personal information</h2>
        <div class="row mb-4">
            <ValidationProvider
                class="col-md-6"
                name="First Name"
                v-slot="{ errors }"
                rules="required|min:3|latin"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">First Name*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="personalInfo.first_name"
                    >
                    <FormError :error="errors[0]" name="First Name"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Last Name"
                v-slot="{ errors }"
                rules="required|min:3|latin"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Last Name*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="personalInfo.last_name"
                    >
                    <FormError :error="errors[0]" name="Last Name"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Date of birth"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Date og Birth*</label>
                    <input
                        type="date"
                        class="form-control pl-4"
                        v-model="personalInfo.birthday"
                    >
                    <FormError :error="errors[0]" name="Date of birth"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Place of birth"
                v-slot="{ errors }"
                rules="required|min:3|latin"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Place of Birth*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="personalInfo.place_of_birth"
                    >
                    <FormError :error="errors[0]" name="Place of birth"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Email"
                v-slot="{ errors }"
            >
                <div class="form-group mb-3">
                    <label class="form-label">Email Address*</label>
                    <input
                        type="email"
                        class="form-control pl-4"
                        v-model="personalInfo.email"
                    >
                    <FormError :error="errors[0]" name="Email"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Home Phone"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Home Phone*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-mask="'+1 (###) ###-####'"
                        v-model="personalInfo.home_phone"
                    >
                    <FormError :error="errors[0]" name="Home Phone"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Cell Phone"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Cell phone*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-mask="'+1 (###) ###-####'"
                        v-model="personalInfo.cell_phone"
                    >
                    <FormError :error="errors[0]" name="Cell Phone"/>
                </div>
            </ValidationProvider>

            <div class="col-md-6">
                <div class="form-group mb-3">
                    <label for="" class="form-label">Your website (if you have one)</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="personalInfo.website"
                    >
                </div>
            </div>
            <ValidationProvider
                class="col-md-6"
                name="Number of Cabins"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Number of Cabins*</label>
                    <input
                        type="number"
                        v-model="personalInfo.cabins"
                        class="form-control pl-4"
                    >
                    <FormError :error="errors[0]" name="Number of Cabins"/>
                    <small class="form-txt">Most cruise lines only offer one cabin, so if you indicate more than one
                        cabin, make sure it is necessary</small>
                </div>
            </ValidationProvider>
        </div>
    </ValidationObserver>


</template>

<script>

import FormError from "../Common/FormError.vue";
import {mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";

export default {
    name: "AdditionalPersonalInfo",
    components: {FormError},
    watch: {
        personalInfo: {
            handler(state) {
                this.dispatchState(state);
            },
            deep: true
        }
    },
    mounted() {
        this.dispatchState(this.personalInfo);
    },

    computed: {
        ...mapState(useArtistStore, {
            personalInfo: 'personalInfo',
        }),
    }
}
</script>

<style scoped>

</style>
